export const VAULT_CATEGORIES = [
  { key: "harassment", label: "Harassment", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  { key: "sexual_harassment", label: "Sexual harassment", cls: "bg-rose-100 text-rose-800 border-rose-300" },
  { key: "discrimination", label: "Discrimination", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  { key: "retaliation", label: "Retaliation", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { key: "bullying", label: "Bullying / intimidation", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  { key: "unsafe", label: "Unsafe or unethical request", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  { key: "other", label: "Other", cls: "bg-slate-50 text-slate-600 border-slate-200" },
];

export const categoryOf = (key) => VAULT_CATEGORIES.find((c) => c.key === key) || VAULT_CATEGORIES[VAULT_CATEGORIES.length - 1];

export const emptyEntry = () => ({
  title: "",
  incident_date: new Date().toISOString().slice(0, 10),
  incident_time: "",
  location: "",
  category: "harassment",
  what_happened: "",
  individuals: [{ name: "", title: "" }],
  witnesses: [],
  supervisor_id: "",
  supervisor_name: "",
});

export function formatIncidentDate(d) {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(y, m - 1, day).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export const formatRecorded = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", timeZoneName: "short" }) : "");

export const formatBytes = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
